import { render, staticRenderFns } from "./CourseViewer.vue?vue&type=template&id=6e80b80d&scoped=true&"
import script from "./CourseViewer.vue?vue&type=script&lang=js&"
export * from "./CourseViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e80b80d",
  null
  
)

export default component.exports